<template>
    <div class="personal-center-page">
      <div class="title">个人信息</div>
      <div class="user-info-content">
        <el-row>
          <el-col :span="8">
            <div class="user-info-basic">
              <el-row>
                <el-col :span="10"><div class="">头像:</div></el-col>
                <el-col :span="14"><div class="upload-user-icon" @click="isDoingUserIconCut = true">上传头像 <i class="el-icon-upload"></i></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">用户名:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.userName}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">昵称:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.nickName || '--'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">真实姓名:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.realName || '--'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">手机号:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.phone || '--'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">座机号:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.fixedPhone || '--'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">邮箱:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.email || '--'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">角色:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.roleName === 'jobseeker' ? '求职者' : '招聘者'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">性别:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.sex === '01' ? '男' : currentUser.sex === '02' ? '女' : '保密'}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">年龄:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.age}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">生日:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.birth | dateFormat("YYYY-MM-DD")}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">创建时间:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">最后更新时间:</div></el-col>
                <el-col :span="14"><div class="">{{currentUser.updateDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</div></el-col>
              </el-row>
              <el-row>
                <el-col :span="10"><div class="">
                  <el-button type="primary" @click="openEditDrawer()">完善个人信息</el-button>
                </div></el-col>
                <el-col :span="14"><div class="">
                  <el-button type="primary" @click="openPasswordDialog()">修改密码</el-button>
                </div></el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="resume-content" v-if="currentUser.roleName === 'jobseeker'">
              <div class="user-resume">简历</div>
              <div class="resume-img">
                <img alt src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3577713179,813478376&fm=11&gp=0.jpg" />
              </div>
             </div>
            <div class="resume-content" v-if="currentUser.roleName === 'enterprise'">
              <div class="user-resume">公司信息</div>
              <div>公司信息功能待完善</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-drawer
        :visible.sync="drawer"
        :append-to-body="true"
        title="修改个人信息"
        :before-close="handleClose">
        <div class="edit-user-info-drawer">
          <el-form label-width="100px" :model="editUserInfo" :rules="userRules" ref="userEditForm">
            <el-form-item label="用户名：" prop="userName">
              <el-input v-model="editUserInfo.userName" placeholder="请填写昵称"></el-input>
            </el-form-item>
            <el-form-item label="昵称：" prop="nickName">
              <el-input v-model="editUserInfo.nickName" placeholder="请填写昵称"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名：" prop="realName">
              <el-input v-model="editUserInfo.realName" placeholder="请填写真实姓名（有利于自己在求职过程中的简历信息完善）"></el-input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="phone">
              <el-input v-model="editUserInfo.phone" placeholder="请填写手机号码"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
              <el-input v-model="editUserInfo.email" placeholder="请填写邮箱"></el-input>
            </el-form-item>
            <el-form-item label="性别：">
              <el-radio-group v-model="editUserInfo.sex">
                <el-radio label="01">男</el-radio>
                <el-radio label="02">女</el-radio>
                <el-radio label="00">保密</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="生日：">
              <el-date-picker
                v-model="editUserInfo.birth"
                align="left"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <!--<el-form-item label="上传简历：" v-if="currentUser.roleName === 'jobseeker'">
              <el-upload
                class="upload-demo"
                ref="upload"
                action="#"
                :limit="1"
                :accept="'.doc,.docx,.pdf'"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="fileAdd"
                :file-list="editUserInfo.resumeData"
                :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选择简历</el-button>
                <span style="color: #fd5f39;font-weight: bolder">简历上传功能待开发</span>
&lt;!&ndash;                <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>&ndash;&gt;
                <div slot="tip" class="el-upload__tip">只能上传doc/docx/pdf文件</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="公司名称：" v-if="currentUser.roleName === 'enterprise'">
              <div class="company-name-input-tip">(招聘者必须绑定公司成功后才可以发布职位信息)</div>
              <el-input v-model="editUserInfo.companyName"></el-input>
            </el-form-item>-->
          </el-form>
          <div class="btn-group">
            <el-button size="small" type="primary" @click="submitUserChange()">保存</el-button>
            <el-button size="small" @click="drawer = false">取消</el-button>
          </div>
        </div>
      </el-drawer>

      <el-dialog :visible.sync="showPasswordChangeFlag" :closeOnClickModal="true" :showClose="true" :width="'400px'"
                 :destroyOnClose="true" :appendToBody="true" :customClass="'change-pw'" :before-close="hidePasswordChangeDialog">
        <div slot="title"><span style="font-size: 16px;color: #313131">修改密码</span></div>
        <el-form :model="userInfo3" :size="'medium'" :rules="userInfoRules" ref="userInfo3">
          <el-form-item label="" prop="number">
            <el-input v-model="userInfo3.number" ref="number" prefix-icon="el-icon-user"
                      placeholder="手机号或邮箱" clearable></el-input>
          </el-form-item>
          <el-form-item label="" prop="code">
            <el-input ref="code" v-model="userInfo3.code"
                      class="login-verification-code"
                      prefix-icon="el-icon-message" placeholder="输入验证码">
              <el-button v-if="verificationCodeFlag" slot="append" @click="checkPhoneNumberAddSendMsg">发送验证码
              </el-button>
              <div v-else slot="append" class="login-waiting-code">已发送 {{waitingCodeTime}} s</div>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input v-model="userInfo3.password" prefix-icon="el-icon-key" placeholder="输入新密码"
                      show-password></el-input>
          </el-form-item>
          <el-form-item label="" prop="passwordConfirm">
            <el-input v-model="userInfo3.passwordConfirm" prefix-icon="el-icon-key" placeholder="确认新密码"
                      show-password></el-input>
          </el-form-item>
        </el-form>
        <div><el-button type="primary" @click="submitResetPassword()" style="width: 100%">确认</el-button></div>
      </el-dialog>

      <user-icon :is-doing-user-icon-cut="isDoingUserIconCut" @closeUserIconDialog="isDoingUserIconCut = false"></user-icon>
    </div>
</template>

<script>
import UserIcon from '../UserIconCut/UserIcon'
import utilService from '../../utils/utilService'
export default {
  name: 'PersonalCenter',
  components: {UserIcon},
  data () {
    // 手机号或邮箱校验
    let validatePhoneOrEmail = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value.trim())) &&
        !(new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$').test(value.trim()))) {
        callback(new Error('请输入正确的手机号码或邮箱'))
      }
      callback()
    }
    // 验证码校验
    let validateVerificationCode = (rule, value, callback) => {
      if (!(/^\d{6}$/.test(value.trim()))) {
        callback(new Error('请输入6位正确的验证码'))
      }
      callback()
    }
    // 密码正则校验
    let validatePass = (rule, value, callback) => {
      if (!/^[\w_-]{6,20}$/.test(value.trim())) {
        callback(new Error('请输入6-20位字母、数字或特殊字符(-_)作为密码'))
      }
      callback()
    }
    // 密码确认
    let validatePass2 = (rule, value, callback) => {
      if (this.userInfo3.password.trim() !== this.userInfo3.passwordConfirm.trim()) {
        callback(new Error('两次输入密码不一致'))
      }
      callback()
    }
    let validateSyn = (rule, value, callback) => {
      utilService.checkSensitive({sensitive: value.trim()}, callback)
    }
    let validatePhone = (rule, value, callback) => {
      value = value || ''
      if (!value.trim() || utilService.isMobile(value.trim())) {
        callback()
      } else {
        callback(new Error('请填写正确的手机号！'))
      }
    }
    let validateEmail = (rule, value, callback) => {
      value = value || ''
      if (this.$store.get('user').roleName === 'enterprise' && !value.trim()) {
        callback(new Error('招聘者必须完善邮箱信息！'))
      } else if (this.$store.get('user').roleName === 'enterprise' && !utilService.isEmail(value.trim())) {
        callback(new Error('请填写正确的邮箱！'))
      } else if (!value.trim() || utilService.isEmail(value.trim())) {
        callback()
      } else {
        callback(new Error('请填写正确的邮箱！'))
      }
    }
    return {
      userRules: {
        userName: [{validator: validateSyn, trigger: 'blur'}],
        nickName: [{validator: validateSyn, trigger: 'blur'}],
        realName: [{validator: validateSyn, trigger: 'blur'}],
        phone: [{validator: validatePhone, trigger: 'blur'}],
        email: [{validator: validateEmail, trigger: 'blur'}]
      },
      isDoingUserIconCut: false,
      currentUser: {
        userName: '',
        nickName: '',
        realName: '',
        phone: '',
        fixedPhone: '',
        email: '',
        roleName: '',
        sex: '',
        age: '',
        birth: '',
        createDate: '',
        updateDate: ''
      },
      editUserInfo: {
        userName: '',
        nickName: '',
        realName: '',
        fixedPhone: '',
        phone: '',
        email: '',
        sex: '',
        birth: '',
        resumeData: [],
        companyName: ''
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      drawer: false,
      showPasswordChangeFlag: false,
      verificationCodeFlag: true,
      waitingCodeTime: 60,
      userInfo3: {
        number: '',
        code: '',
        password: '',
        passwordConfirm: ''
      },
      userInfoRules: {
        phone_email: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        number: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        passwordConfirm: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    openEditDrawer () {
      this.drawer = true
      this.editUserInfo = {
        userName: this.currentUser.userName || '',
        nickName: this.currentUser.nickName || '',
        realName: this.currentUser.realName || '',
        fixedPhone: this.currentUser.fixedPhone || '',
        phone: this.currentUser.phone || '',
        sex: this.currentUser.sex || '',
        birth: this.currentUser.birth || '',
        resumeData: [],
        companyName: ''
      }
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          console.log(this.editUserInfo)
          done()
        })
        .catch(_ => {})
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
      this.editUserInfo.resumeData = []
    },
    handlePreview (file) {
      console.log(file)
    },
    fileAdd (file, fileList) {
      console.log(file.raw)
      this.editUserInfo.resumeData.push(file)
    },
    submitUserChange () {
      this.$refs['userEditForm'].validate((valid) => {
        if (valid) {
          this.$http.put(this.$api.updateUser.url, {
            id: this.$store.get('user').id,
            userName: this.editUserInfo.userName,
            nickName: this.editUserInfo.nickName,
            realName: this.editUserInfo.realName,
            fixedPhone: this.editUserInfo.fixedPhone,
            phone: this.editUserInfo.phone,
            sex: this.editUserInfo.sex,
            email: this.editUserInfo.email,
            birth: new Date(this.editUserInfo.birth).getTime()
          }).then(_ => {
            if (_ && _.code === 200) {
              this.$message.success('个人信息更新成功')
              this.currentUser = _.data
              this.$store.set('user', _.data)
              this.$store.session.set('user', _.data)
              this.drawer = false
            } else if (_.msg) {
              this.$message.error(_.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    openPasswordDialog () {
      this.showPasswordChangeFlag = true
    },
    hidePasswordChangeDialog () {
      this.showPasswordChangeFlag = false
    },
    checkPhoneNumberAddSendMsg () {
      // let form = this.isResetPassword ? 'userInfo3' : 'userInfo2'
      // let number = this.showPasswordChangeFlag ? 'number' : 'phone_email'

      this.$refs['userInfo3'].validateField('number', (errMsg) => {
        if (!errMsg) {
          this.verificationCodeFlag = false
          if (this.showPasswordChangeFlag) {
            this.$refs.code.focus()
          } else {
            this.$refs.loginVerificationCode.focus()
          }
          let timer = setInterval(() => {
            this.waitingCodeTime--
            if (this.waitingCodeTime === 0) {
              this.waitingCodeTime = 60
              clearInterval(timer)
              this.verificationCodeFlag = true
            }
          }, 1000)
          // 调接口发送验证码
          let param = {number: ''}
          param.number = this.userInfo3.number
          this.$http.get(this.$api.getVerificationCode.url, param).then(res => {
            console.log(res)
          })
        } else {
          this.$refs.number.focus()
        }
      })
    },
    submitResetPassword () {
      this.$refs['userInfo3'].validate((valid) => {
        if (valid) {
          /**
           * 调就接口重置用户密码
           * */
          this.$http.put(this.$api.updatePassword.url, {
            number: this.userInfo3.number,
            code: this.userInfo3.code,
            newPassword: this.userInfo3.password
          }).then(res => {
            if (res && res.code === 200) {
              this.userInfo3 = {
                number: '',
                code: '',
                password: '',
                passwordConfirm: ''
              }
              this.$message.success('密码修改成功')
              this.hidePasswordChangeDialog()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          return false
        }
      })
    }
  },
  created () {
    this.currentUser = this.$store.get('user')
  }
}
</script>

<style scoped>
  .personal-center-page {
    width: 1200px;
    margin: auto;
    background: #ffffff;
    min-height: calc(100vh - 60px);
    text-align: left;
  }

  .title {
    font-size: 18px;
    padding: 20px;
    color: #409EFF;
  }
  .user-info-content {
    padding: 0 20px;
    font-size: 16px;
    min-height: 800px;
  }
  .el-row {
    margin-bottom: 30px;
  }
  .user-info-basic {
    height: calc(100vh - 160px);
  }
  .resume-content {
    height: calc(100vh - 160px);
    padding-left: 40px;
    border-left: 1px dashed #cccccc;
  }
  .user-resume {
    margin-bottom: 10px;
  }
  .resume-img {
    text-align: center;
  }
  .edit-user-info-drawer {
    width: 100%;
    height: 100%;
    padding: 20px;
  }
  /deep/ .el-drawer__header {
    margin-bottom: 0;
  }
  .upload-user-icon {
    color: #409EFF;
    cursor: pointer;
  }
  .upload-user-icon:hover {
    text-decoration: underline;
  }
  .company-name-input-tip {
    position: absolute;
    left: 70px;
    top: -50px;
    font-weight: bolder;
    color: #fd5f39;
  }
  /deep/ .el-drawer__header>:first-child {
    font-size: 16px;
    outline: none;
    position: relative;
  }
  /deep/ .el-drawer__header>:first-child::before {
    position: absolute;
    content: '';
    width: 4px;
    height: 24px;
    background: #409EFF;
    left: -20px;
  }
  /deep/ .el-drawer__body {
    /*noinspection CssInvalidPropertyValue*/
    overflow: overlay;
  }
  /deep/ .btn-group {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/PersonalCenter.vue